
class Parallax {

    constructor( elem ) {

        this.$elem = elem;

        if ( !this.$elem )
            return;

        this.$speed = parseFloat( this.$elem.data('parallax') || -1 );
        this.$winHeight = $(window).height();
        this.$parent = this.$elem.parent();

        if ( !this.$parent )
            return;

        this.$parentHeight = this.$parent.innerHeight();

        $(document).on( 'ready' , this.parallax.bind(this) );
        $(document).on( 'scroll', this.parallax.bind(this) );
        
    }

    parallax() {

        $parentY = this.$parent.offset().top;
        $winY = $(document).scrollTop();
        $winBottom = $winY + this.$winHeight;

        // console.log($winBottom + '>' + $parentY + ' ' + $winY + '<' + $parentY + '+' + this.$parentHeight);

        if ($winBottom > $parentY && $winY < $parentY + this.$parentHeight) {
            $imgBottom = (($winBottom - $parentY) * this.$speed);
            $imgTop = this.$winHeight + this.$parentHeight;
            $imgPercent = (($imgBottom / $imgTop) * 100) + (50 - (this.$speed * 50));

            // console.log( '$imgBottom:' + $imgBottom + ' $imgTop:' + $imgTop + ' $imgPercent:' + $imgPercent);

            this.$elem.css({
                // causes init jump
                top: $imgPercent + '%',
                transform: 'translate(-50%, -' + $imgPercent + '%)'
            });
        }        

    }

}

$('[data-parallax]').each( function( index, elem ){
    new Parallax( $(elem) );
} );